// @ts-strict-ignore
import { PrivilegesQuery } from '@generated'
import { MultipleItemResponse } from '@lib/kontent'
import { PrivilegeItem } from '@lib/kontent/models/PrivilegeItem'

export function getDafAndKenticoPrivileges(
  privileges: MultipleItemResponse<PrivilegeItem>,
  data: PrivilegesQuery,
) {
  if (data && data.privileges && privileges && privileges.items.length > 0) {
    const filteredItems = privileges.items.filter((item, key) => {
      return data.privileges.find(
        (i) =>
          i.privilege_nr === item.elements.privilege_number.value &&
          item.elements.category.value[0] &&
          item.elements.rich_content.value[0],
      )
    })

    // There's no real way of sorting the privileges by newest first
    // by sorting based on the privilege number we can probably get the newest privileges first
    return filteredItems.sort(
      (a, b) => b.elements.privilege_number.value - a.elements.privilege_number.value,
    )
  }

  return []
}
